import { ChannelConfig } from '../../../../types/ad-channels';

export const MACRO_CHANNEL_CONFIG: Record<string, ChannelConfig> = {
  google: {
    value: 'google',
    label: 'Google Ads'
  },
  meta: {
    value: 'meta',
    label: 'Meta Ads'
  }
};
